module.exports = __webpack_public_path__ + "img/maas_wrapbg12.f0ad3e52.png";